export const usersApi = 'https://randomuser.me/api/?results=30'
